import type { BaseIpgConfig } from '../../../backend_config.types';
import type { CloverGatewayEnvironment } from './clover-gateway-environment.types';
import { CloverIpgSystemId } from './clover-system-constants';

export const CloverTerminalTransport = {
    CLOUD_PAY_DISPLAY: 'CLOUD_PAY_DISPLAY',
} as const;

export type CloverTerminalTransport =
    (typeof CloverTerminalTransport)[keyof typeof CloverTerminalTransport];

export interface CloverIpgConfigBase extends Omit<BaseIpgConfig, 'ipg_id'> {
    readonly ipg_id: typeof CloverIpgSystemId;
    readonly terminal_transport:
        typeof CloverTerminalTransport.CLOUD_PAY_DISPLAY;
}

export interface CloverSandboxIpgConfig extends CloverIpgConfigBase {
    readonly environment: typeof CloverGatewayEnvironment.SANDBOX;
}

export interface CloverProductionIpgConfig extends CloverIpgConfigBase {
    readonly environment: typeof CloverGatewayEnvironment.PRODUCTION;
}

export type CloverIpgConfig =
    | CloverSandboxIpgConfig
    | CloverProductionIpgConfig;

export type CloverIpgConfigCustomization = {
    readonly ipg_id: typeof CloverIpgSystemId;
    readonly environment: CloverGatewayEnvironment;
};
